import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useLang } from "../LanguageContext";

function Navbar() {
  const { pathname } = useLocation();
  const { lang, setLang, t } = useLang();

  const NAV_LINKS = [
    { to: "/",           key: "nav.home"          },
    { to: "/timer",      key: "nav.businessTools"  },
    { to: "/evtools",    key: "nav.evTools"        },
    { to: "/cablecalc",  key: "nav.camperTools"    },
    { to: "/development",key: "nav.development"    },
    { to: "/imprint",    key: "nav.imprint"        },
  ];

  return (
    <nav className="topnav">
      {/* <span className="topnav-brand">steuernagel.net</span> */}
      <div className="topnav-links">
        {NAV_LINKS.map(({ to, key }) => (
          <Link
            key={to}
            to={to}
            className={pathname === to ? "topnav-link active" : "topnav-link"}
          >
            {t(key)}
          </Link>
        ))}
      </div>
      <div className="lang-toggle">
        <button
          type="button"
          className={lang === "en" ? "active" : ""}
          onClick={() => setLang("en")}
        >
          EN
        </button>
        <button
          type="button"
          className={lang === "de" ? "active" : ""}
          onClick={() => setLang("de")}
        >
          DE
        </button>
      </div>
    </nav>
  );
}

export default Navbar;
